export enum TestResultDataType {
    FLOW = "FLOW",
    FLOW_STEP = "FLOW_STEP",
    FLOW_SEQUENCE = "FLOW_SEQUENCE",
    FLOW_BRANCH = "FLOW_BRANCH",
    FLOW_RETURN_BRANCH = "FLOW_RETURN_BRANCH",

    FORM = "FORM",

    EXPRESSION = "EXPRESSION",
    EXPRESSION_VALUE = "EXPRESSION_VALUE",
    EXPRESSION_ELEMENT = "EXPRESSION_ELEMENT",
    STATEMENT_RULE = "STATEMENT_RULE",
    // more here.

    // value table rule
    VALUE_TABLE_RULE = "VALUE_TABLE_RULE",
    VALUE_TABLE_RULE_ROW = "VALUE_TABLE_RULE_ROW",
    VALUE_TABLE_RULE_RULE_COLUMN = "VALUE_TABLE_RULE_RULE_COLUMN",

    // rule table
    RULE_TABLE = "RULE_TABLE",
    RULE_TABLE_ROW = "RULE_TABLE_ROW",
    RULE_TABLE_COLUMN = "RULE_TABLE_COLUMN",

    // intersection rule
    INTERSECTION_RULE = "INTERSECTION_RULE",
    INTERSECTION_X_RULE = "INTERSECTION_X_RULE",
    INTERSECTION_Y_RULE = "INTERSECTION_Y_RULE",

    // Tree Rule
    TREE_RULE = "TREE_RULE",
    TREE_NODE_RULE = "TREE_NODE_RULE",

    TEXT_MERGE = "TEXT_MERGE",
    TEXT_MERGE_VALUE = "TEXT_MERGE_VALUE",
}
